
import React from "react";
import CustomSystem from "../../../ui/svg/common/custom-system";
import { useAppDispatch, useAppSelector} from "../DAL/store";
import {OnSystemTypeClickChangeState} from "../services/logic-helper";
import "../carusel-events";
/**
 *  Select an existing system OR Build your own custom system
 */
const SelectSystem = () => {


    const PresetGroupList = useAppSelector((store) => store.PresetGroupList);
    const ImageCDNDomain = useAppSelector((store) => store.ImageCDNDomain);
    const UserState_SystemType = useAppSelector((store) => store.UserState_SystemType);
    const SBL_BuilderPage = useAppSelector((store) => store.SBL_BuilderPage);
    const dispatch = useAppDispatch();

    const SetSystemType = (presetId : number,isCustom:boolean) => {
        if(isCustom){

            OnSystemTypeClickChangeState("c",
                UserState_SystemType,
                SBL_BuilderPage.sbl_BuilderPagePresetList,
                SBL_BuilderPage.sbl_BuilderPageMainList,
                SBL_BuilderPage,
                dispatch);
        }else{

            OnSystemTypeClickChangeState("p-" + presetId,
                UserState_SystemType,
                SBL_BuilderPage.sbl_BuilderPagePresetList,
                SBL_BuilderPage.sbl_BuilderPageMainList,
                SBL_BuilderPage,
                dispatch);
        }

    }
    /**
     *
     */

    return (
        <div className="w-full ">
            <div className="text-xl md:text-2xl font-bold md:mt-6">1. Select an existing system OR Build your own custom system</div>
            <div  className="mt-8 carousel relative" data-carusel-mode="mobile">
                <div className="arr-left py-1 flex items-center h-full z-50" style={{display:"none"}}>
                    <div className="py-2 bg-white flex justify-center items-center h-full w-full">&lt;</div>
                </div>
                <ul id="systemcarusel" className="carousel-slides flex flex-wrap" data-carusel="mobile" style={{left:0}}>
                    {PresetGroupList.map((k, key) =>
                        <li className={`carousel-row w-fit bg-gray-100 m-1 mx-2 md:mx-1 xl:mx-4 cursor-pointer p-3 rounded ${UserState_SystemType === "p-" + k.presetID? "border-2 border-blue-200":"" }`}
                            key={key}
                            id={"item-" + k.presetID}
                            onClick={(e) => {
                                SetSystemType(k.presetID,false );
                            }}>
                            <button type='button' className="w-40 h-full" style={{height:"230px"}} >
                                <div className="pb-4">
                                    <img  src={ImageCDNDomain +k.presetImage}
                                          title={k.presetDisplayName}
                                          alt={k.presetDisplayName} />
                                </div>
                                <div className="text-center" style={{lineHeight:"normal"}}>
                                    {k.presetDisplayName}
                                </div>
                            </button>

                        </li>
                    )}

                </ul>
                <div className="arr-right py-1 flex justify-center items-center h-full z-50" style={{display:'none'}}>
                    <div className="arr-bg py-2  flex justify-center items-center h-full w-full">&nbsp;</div>
                </div>
            </div>

            <ul className="w-full">
                <li className={`w-40 bg-gray-100 m-2 md:mx-4  flex items-center justify-center cursor-pointer p-3 rounded ${UserState_SystemType === "c"? "border-2 border-blue-200":"" }`}
                    style={{height:"230px"}}
                    value={""}
                    onClick={(e) => {
                        SetSystemType(0,true )

                    }}>
                    <button type='button'        className="bg-gray-100 py-4">
                        <div className="flex items-center justify-center pb-4">
                            <CustomSystem color={"#3659f6"} width={"70px"}/>
                        </div>
                        <div className="text-center text-blue-200">
                            Build your own <br/> custom system
                        </div>

                    </button>
                </li>
            </ul>
        </div>
    );
};

export default SelectSystem;


